import { ChangeEvent, FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Input } from '@base-app';
import { Variants } from '@/common/types';
import { CustomInputProps } from './CustomInput.types';
import { StyledLabel, StyledTarget } from './CustomInput.styles';
import { InputType } from '../../ManualForm.types';
import { maskPhoneNumber } from '@/common/utils';

const CustomInput: FC<CustomInputProps> = ({ field, index, isEditing }) => {
  const methods = useFormContext();
  const type = field.type;
  const id = `custom-input-${field.name.split(' ').join('-').toLocaleLowerCase()}`;
  const isSensitive = field.isSensitive ?? false;

  const { control, setValue } = methods;

  return (
    <>
      <StyledLabel data-testid={`custom-input-label`}>{field.name}</StyledLabel>
      {!isEditing && <StyledTarget data-testid={id}>{field.target}</StyledTarget>}
      {isEditing && (
        <Controller
          control={control}
          defaultValue={field.target}
          name={`${field.section}.${index}.target`}
          render={({ field, fieldState: { error } }) => {
            return (
              <Input
                {...methods.register(field.name)}
                {...field}
                css={{ backgroundColor: '$white', width: '100%' }}
                error={!(error?.message == null)}
                errorDescription={error?.message as string}
                id={field.name}
                label={''}
                name={field.name}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  field.onChange(event);

                  if (type === InputType.PHONE) {
                    setValue(field.name, maskPhoneNumber(event.target.value));
                  }
                }}
                placeholder={field.value?.toString()}
                role="custom-input"
                testId={id}
                type={type}
                value={field.value}
                variant={Variants.PRIMARY}
                isSensitive={isSensitive}
              />
            );
          }}
        />
      )}
    </>
  );
};

export default CustomInput;
